<template lang="pug">
    model-data-table(
        loading-text="Cargando clientes..."
        no-data-text="Sin clientes."
        ref="table"
        remind-key='sl-customer-list'
        v-bind="tableProps"
        @detail="submitShow"
        @remove="submitRemove"
        :no-detail="!$can('VIEW_DETAIL_SALE_CUSTOMER')"
        :no-remove="!$can('DELETE_SALE_CUSTOMER')"
        )
</template>

<script>
import { ModelDataTable } from '@/components/reusable_components/next'
import { mapActions, mapState } from 'vuex'

//
import CustomerService from '@/services/api/customer/CustomerService'
//-
import MdlCustomer from '../../models/Sale/SlCustomer'
import FiltersCustomer from './filters'
import HeadersCustomer from './headers'
//
export default {
    name: 'customer-list',
    props: {},
    data: function() {
        return {
            filters: FiltersCustomer,
            headers: HeadersCustomer,
            selected: [],
            itemDeleteId: null,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        tableProps() {
            return {
                filters: this.filters,
                headers: this.headers,
                service: MdlCustomer,
            }
        },
    },
    methods: {
        //-
        submitShow: function(event) {
            this.$router.push(`/customers/${event.item.id}`)
        },
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        submitRemove(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('ELIMINAR')

            //
            let payload = this.fillSnack(
                'warning',
                'Advertencia',
                '¿Desea eliminar cliente?'
            )
            this.initSnackbar(payload)

            //
            this.itemDeleteId = event.item.id
        },
    },
    watch: {
        async responseConfirm(val) {
            //
            if (val === 'ELIMINAR') {
                //
                this.resetSnackbarState()

                //
                let response = await CustomerService.deleteCustomer(
                    this.itemDeleteId
                )

                //
                if (response.status == 200) {
                    //
                    let payload = this.fillSnack(
                        'success',
                        'Cliente eliminado.',
                        ''
                    )
                    this.initSnackbar(payload)

                    //
                    this.$router.go()
                } else {
                    //
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.message + '. ' + response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'model-data-table': ModelDataTable,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    created() {
        this.setTitleTopBar('Clientes')
        this.$setItemsTopBar([
            {
                text: 'crear cliente',
                icon: 'add',
                can: 'CREATE_SALE_CUSTOMER',
                action: () => {
                    this.$router.push('/customers/create')
                },
            },
        ])
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_SALE_CUSTOMER')) ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
